module.exports = __webpack_public_path__ + "static/media/karlsborg.d6fddac2.jpeg";